module.exports = __webpack_public_path__ + "static/img/dyy.8c8cff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dyy.png
// module id = Tb+0
// module chunks = 1